import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../core/shared/widget/widget-data";
import {ObjectTypeService} from "../../../../core/cc/service/api/object-type.service";
import {MvsCoreService} from "../../../../core/shared/service/mvs-core.service";
import {FilterCriteria} from "../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../core/shared/dto/object/request/object-request-list";
import {Sorting} from "../../../../core/shared/misc/sorting";
import {PagingDto} from "../../../../core/shared/dto/model/paging.dto";
import {WidgetFactory} from "../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../core/shared/widget/widget-data-param";

@Component({
    selector: 'mvs-xx-object-document-component',
    templateUrl: './object-documents.component.html',
    standalone: false
})
export class XxObjectDocumentComponent implements OnInit {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() objectTypeId: number;
    @Input() objectTypeAlias: string;
    @Input() objectId: number;
    visible:boolean;
    documentObject:any;

    widgetTableDocument: WidgetData;
    protected objectTypeService: ObjectTypeService;

    constructor(protected coreService: MvsCoreService) {
    }

    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {

        this.objectTypeService = <ObjectTypeService>this.coreService.getCrudService("cc.ObjectType");

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.refreshAssignedDocuments()

        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    refreshAssignedDocuments() {

        if (!this.objectTypeId) {
            this.getObjectType(this.objectTypeAlias);
            return;
        }
        const filterCriteriaList = [];

        filterCriteriaList.push(FilterCriteria.createSingleCondition('objectType', FilterCriteria.cOperatorEqual, this.objectTypeId, null));
        filterCriteriaList.push(FilterCriteria.createSingleCondition('objectId', FilterCriteria.cOperatorEqual, this.objectId, null));

        const dataProviderListRequest = ObjectRequestList.createWithPaging(
            true,
            filterCriteriaList,
            [new Sorting("lastModifiedDate", false)],
            PagingDto.create(0, 5)
        );
        this.widgetTableDocument = WidgetFactory.createWidgetTableEntity(
            'document.show.object.documents',
            'Zugewiesene Dokumente',
            'dm.DmDocumentAssignment',
            'No Records Found',
            dataProviderListRequest,
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
    }

    getObjectType(objectTypeAlias: string) {
        this.objectTypeService.getViaObjectType(objectTypeAlias).then((res: any) => {
            this.objectTypeId = res.id;
            this.refreshAssignedDocuments();
        })
    }

    onObjectSelect(event) {
        this.documentObject = event;
        this.visible = true;
    }
}
